import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { SideMenu, BackHeader } from "./../../components";
import { Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
const LeaveRequestCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">{location.state.type} leave request</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Leave title</p>
                <input
                  type="text"
                  name="title"
                  className="input"
                  placeholder="enter your dispute title"
                />
              </div>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <p className="input-heading">Leave Description</p>
              <textarea
                className="textarea"
                placeholder="Enter your course descriptions"
                rows="20"
                cols="40"
              ></textarea>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Start date</p>
                <input type="date" className="input" placeholder="Start date" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">end date</p>
                <input type="date" className="input" placeholder="Start Time" />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                {location.state.type === "Create" ? "Submit" : "Updade"}
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default LeaveRequestCreate;
